"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorLogStyles = exports.errorLogTypes = void 0;

var _errorLogStyles;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var errorLogTypes = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS'
};
exports.errorLogTypes = errorLogTypes;
var commonStyle = 'font-weight: bold; color: #fff;';
var errorLogStyles = (_errorLogStyles = {}, _defineProperty(_errorLogStyles, errorLogTypes.ERROR, "background-color: red; ".concat(commonStyle)), _defineProperty(_errorLogStyles, errorLogTypes.WARNING, "background-color: orange; ".concat(commonStyle)), _defineProperty(_errorLogStyles, errorLogTypes.INFO, "background-color: blue; ".concat(commonStyle)), _defineProperty(_errorLogStyles, errorLogTypes.SUCCESS, "background-color: green; ".concat(commonStyle)), _errorLogStyles);
exports.errorLogStyles = errorLogStyles;
//# sourceMappingURL=constants.js.map